module.exports = __webpack_public_path__ + "static/media/doremi_00040.062bc27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/doremi_00040.png
// module id = 255
// module chunks = 0